// 单文件引入方式

import Switch from './ZuiSwitch.vue'

export default {
  install(Vue) {
    Vue.component('ZuiSwitch', Switch)
  }
}

export { Switch }
